import React, { useState, useEffect } from 'react';
import PhoneVerification from '../../components/PhoneVerification.js';
import Cookies from 'js-cookie';

function AdvertisingManagementInterfaceMenu() {
  const [isVerified, setIsVerified] = useState(false);
  const domain = "https://server.hazran.online";

  // בדיקה אם המשתמש כבר מאומת (באמצעות קוקיס)
  useEffect(() => {
    const token = Cookies.get('verificationToken');
    if (token) {
      setIsVerified(true);
    }
  }, []);

  useEffect(() => {
    // הגדרת רקע לכל העמוד
    document.body.style.backgroundImage = 'url("/background.jpg")';
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundPosition = 'center';

    // יצירת הקישור דינמית
    const link = document.createElement('a');
    link.href = 'https://hazran.online';
    link.textContent = ' עזרן - נתב בינה מלאכותית טלפוני hazran.online';
    link.style.display = 'block';
    link.style.textAlign = 'center';
    link.style.marginTop = '20px';
    link.style.color = '#ffffff';
    link.style.textDecoration = 'none';
    link.style.fontSize = '14px';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    // הוספת הקישור לגוף הדף
    document.body.appendChild(link);

    // ניקוי: הסרת הרקע והקישור בעת unmount
    return () => {
      document.body.style.backgroundImage = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundPosition = '';
      document.body.removeChild(link);
    };
  }, []);

  // אם המשתמש לא מאומת, מציגים את קומפוננטת האימות
  if (!isVerified) {
    return (
      <PhoneVerification 
        domain={domain} 
        onVerified={() => setIsVerified(true)} 
      />
    );
  }

  // פונקציית יציאה: מוחקת את הקוקיס ומעדכנת את isVerified
  const handleLogout = () => {
    Cookies.remove('phoneNumber');
    Cookies.remove('verificationToken');
    setIsVerified(false);
  };

  // סגנון עבור האלמנט העליון
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto', // כדי שהגובה יתאים לתוכן
    backgroundColor: 'rgba(255, 255, 255, 0.5)', // שקיפות חלקית
    borderRadius: '10px',
    padding: '40px', // הגדלת הרווח בפנים
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // מסגרת עם צל עדין
    maxWidth: '600px', // לרספונסיביות
    margin: '50px auto', // מרכז הדף עם מרווח מלמעלה ומלמטה
    gap: '20px', // מוסיף רווח בין האלמנטים בפנים
  };

  const buttonStyle = {
    marginTop: '20px',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    backgroundColor: '#007BFF',
    color: 'white',
    fontSize: '16px',
    width: '80%'
  };

  const logoutButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#dc3545' // צבע אדום לכפתור יציאה
  };

  return (
    <div style={containerStyle}>
      <h1>ממשק ניהול פרסום</h1>
      <button 
        onClick={() => { window.location.href = `/AdvertisingManagementInterface/StartCampaign`; }} 
        style={buttonStyle}
      >
        קמפיין חדש
      </button>
      <button 
        onClick={() => { window.location.href = `/AdvertisingManagementInterface/AdvertisingForUser`; }} 
        style={buttonStyle}
      >
        הקמפיינים שלי
      </button>
      <button onClick={handleLogout} style={logoutButtonStyle}>
        יציאה
      </button>
    </div>
  );
}

export default AdvertisingManagementInterfaceMenu;
